(function () {
var $875fbb29d862d4a6$var$lib = {
    selectors: {
        wrapper: '.logos',
        logoContent: '.logos__container'
    },
    classes: {
        animated: 'logos--animated'
    }
};
/**
 * Animated Logos
 */ var $875fbb29d862d4a6$var$setAnimationDuration = function(container) {
    var _container_querySelector;
    var animationTime = 45;
    var _container_querySelector_clientWidth;
    var innerLength = (_container_querySelector_clientWidth = (_container_querySelector = container.querySelector($875fbb29d862d4a6$var$lib.selectors.logoContent)) === null || _container_querySelector === void 0 ? void 0 : _container_querySelector.clientWidth) !== null && _container_querySelector_clientWidth !== void 0 ? _container_querySelector_clientWidth : 0;
    var halfOfInnerLength = innerLength / 2;
    container.style.setProperty('--animation-time', "".concat(halfOfInnerLength / animationTime, "s"));
};
var $875fbb29d862d4a6$var$initLogoAnimation = function(container) {
    container.setAttribute('data-animated', 'true');
    var logoContainer = container.querySelector($875fbb29d862d4a6$var$lib.selectors.logoContent);
    var logos = Array.from(logoContainer.children);
    logos.forEach(function(logo) {
        var duplicatedItem = logo.cloneNode(true);
        if (!(duplicatedItem instanceof Element)) return;
        duplicatedItem.setAttribute('aria-hidden', 'true');
        logoContainer.appendChild(duplicatedItem);
    });
    $875fbb29d862d4a6$var$setAnimationDuration(container);
};
/**
 * Lazy Loading of Logo Masks
 */ var $875fbb29d862d4a6$var$observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        var container = entry.target;
        // If the logo container is in the user's field of vision, load the logos.
        if (entry.isIntersecting) {
            // Iterate over each logo and set the mask image url.
            Array.from(container.querySelector($875fbb29d862d4a6$var$lib.selectors.logoContent).children).forEach(function(logo) {
                var logoUrl = logo.getAttribute('data-logo');
                if (logo instanceof HTMLElement) {
                    logo.removeAttribute('data-logo');
                    logo.style.setProperty('--mask-img-url', "url(".concat(logoUrl, ")"));
                    logo.setAttribute('data-logo-loaded', 'true');
                }
            });
            observer.unobserve(container);
        }
    });
});
// Init
window.addEventListener('load', function() {
    document.querySelectorAll($875fbb29d862d4a6$var$lib.selectors.wrapper).forEach(function(container) {
        $875fbb29d862d4a6$var$observer.observe(container);
        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (container.classList.contains($875fbb29d862d4a6$var$lib.classes.animated) && !prefersReducedMotion) $875fbb29d862d4a6$var$initLogoAnimation(container);
    });
});

})();
//# sourceMappingURL=logo.min.js.map
